import storageSession from "redux-persist/lib/storage/session";
export default storageSession;
